/*                               */
export function getWidth(): number {
  return window.innerWidth;
}

/*                                */
export function getHeight(): number {
  return window.screen.height;
}

/*                             */
export function getDevicePixelRatio(): number {
  return window.devicePixelRatio || 0;
}
